<template>
    <div>
        <v-card elevation="0">
            <v-card color="#80CBC4" elevation="0" height="100px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-email-edit-outline</v-icon>
                    &nbsp;Edit Email Receipt
                </v-card-title>
            </v-card>
            <v-card-text>
                <EmailReceipt />
            </v-card-text>
        </v-card>
        <iframe name="hiddenFrame" hidden></iframe>
    </div>
</template>
<script>
import EmailReceipt from "../../../components/Admin/Settings/EmailReceipt.vue"
export default {
    components: {
        EmailReceipt
    }
}
</script>